import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetAds = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (status) {
        params['is_active'] = status == "1" ? true : false;
    }

    if (keyword) {
        params['name'] = keyword;
    }

    params['paginate'] = is_paginate;
    const response = await GET(apiUrl.advertisement, params);
    return response;
}


export const UpdateAds = async (id, data) => {
    const response = await PUT(apiUrl.advertisement, id, data);
    return response;
}